import { FunctionalLocationNode, WorkOrderWithScore } from './functional-location-hierarchy-scores-propagation.utils';

export class OperationsHoursCalculator {
  static calculateOperationsHours(node: FunctionalLocationNode): void {
    const childrenReleasedHours = node.Children.reduce((sum, child) => sum + (child.ReleasedHours || 0), 0);
    const childrenNonReleasedHours = node.Children.reduce((sum, child) => sum + (child.NonReleasedHours || 0), 0);
    const releasedHours = node.ReleasedWorkOrders.reduce((sum, wo) => sum + wo.TotalWorkHours, 0);
    const nonReleasedHours = node.NotReleasedWorkOrders.reduce((sum, wo) => sum + wo.TotalWorkHours, 0);
    node.ReleasedHours = Math.round(releasedHours + childrenReleasedHours);
    node.NonReleasedHours = Math.round(nonReleasedHours + childrenNonReleasedHours);
  }
}
